<template>
  <div>
    <el-form
      ref="ruleForm"
      label-position="left"
      :model="ruleForm"
      :rules="rules"
      label-width="150px"
      class="demo-ruleForm"
    >
      <div style="display:flex">
        <el-form-item
          label="广告主账户id"
          prop="account_id"
        >
          <div style="display:flex">

            <el-button
              type="success"
              size="mini"
              @click="selectID"
            >选择</el-button>
            <el-tag v-if="ruleForm.account_id">{{ ruleForm.account_id }}-{{ account_name }}</el-tag>
          </div>
        </el-form-item>
        <el-form-item
          label="营销载体类型"
          label-width="150px"
          prop="second_category_type"
          autocomplete="new-password"
        >
          <el-select
            v-model="ruleForm.second_category_type"
            placeholder="请选择"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
      </div>
      <div>
        <el-form-item
          label="监测链接组名称"
          label-width="150px"
          prop="feedback_name"
          autocomplete="new-password"
        >
          <el-input
            v-model.trim="ruleForm.feedback_name"
            style="width: 430px;"
            placeholder="请输入"
          />
        </el-form-item>
        <el-card class="box-card">

          <el-form-item
            label="监测链接组信息"
            label-width="120px"
            prop="url_info_list"
            autocomplete="new-password"
            style="max-height: 550px;
      overflow-y: scroll;position: relative;"
          >
            <div style="float: right;position: absolute;top: 0px;right: 38px;">
              <el-button
                type="success"
                icon="el-icon-plus"
                circle
                @click="add"
              />
            </div>
            <div
              v-for="item,i in ruleForm.url_info_list"
              :key="i"
            >
              <div style="display: flex; margin-right: 5px;margin-top: 50px; ">

                <div class="item">
                  第{{ i+1 }}条
                </div>
                <div class="item">
                  <span class="title">
                    监测链接
                  </span>
                  <el-input
                    v-model.trim="item.feedback_url"
                    type="textarea"
                    style="width: 200px;"
                    placeholder="请输入"
                  />

                </div>
                <div class="item">
                  <span class="title">
                    监测链接类型
                  </span>
                  <el-select
                    v-model="item.feedback_type"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="obj in feedback_type_options"
                      :key="obj.value"
                      :label="obj.label"
                      :value="obj.value"
                    />
                  </el-select>
                </div>
                <div
                  v-if="ruleForm.url_info_list.length>1"
                  class="item"
                >
                  <el-button
                    type="danger"
                    icon="el-icon-delete-solid"
                    circle
                    @click="rightclick(i)"
                  />
                </div>
              </div>
              <span
                v-if="i==0"
                style="font-size: 10px;color: #ccc;"
              >
                链接示例：https://zy-api.jingxuansz.com/jh/test/?adgroup_id=__ADGROUP_ID__&ad_id=__AD_ID__&callback=__CALLBACK__&click_id=__CLICK_ID__&click_time=__CLICK_TIME__&account_id=__ACCOUNT_ID__
              </span>
            </div>
          </el-form-item>
        </el-card>

      </div>

      <el-form-item style="margin-top: 50px;margin-left: 400px;">
        <el-button
          type="primary"
          @click="submitForm('ruleForm')"
        >确定</el-button>
      </el-form-item>
    </el-form>
    <el-dialog
      title="图片库"
      :close-on-click-modal="false"
      :visible.sync="dialogVisibletwo"
      width="50%"
      append-to-body
    >
      <chooseimg
        ref="mychild"
        @clickicon="clickicon"
      />
    </el-dialog>
    <el-dialog
      title="选择广告主账户id"
      :close-on-click-modal="false"
      :visible.sync="dialogVisibleId"
      width="50%"
      append-to-body
    >
      <accoutIdDialog
        ref="id"
        @close="close"
      />
    </el-dialog>
  </div>
</template>
<script>
import chooseimg from '@/views/sourceMaterial/components/imgComp.vue'
// import { alldatalist } from '@/api/providerAccountManagement/servicePorviderList.js'
import accoutIdDialog from './accoutIdDialog.vue'
export default {
  components: {
    chooseimg,
    accoutIdDialog
  },
  data() {
    return {
      ruleForm: {
        account_id: '',
        feedback_name: '',
        second_category_type: '',
        url_info_list: [
          {
            feedback_url: '',
            feedback_type: ''
          }
        ]
      },
      account_name: '',
      dialogVisibleId: false,
      wechatname: '',
      rules: {
        account_id: [{ required: true, message: '请选择', trigger: 'blur' }],
        feedback_name: [{ required: true, message: '请输入', trigger: 'blur' }],
        second_category_type: [{ required: true, message: '请选择营销载体类型', trigger: 'blur' }]
      },
      loading: false,
      tableData: {
        list: [],
        total: 10
      },
      dialogVisible: false,
      check: undefined,
      wechatVisible: false,
      dialogVisibler: false,
      dialogMerchant: false,
      arrs: [],
      merchant_ids: [],
      typer: null,
      idr: null,
      dialogVisibletwo: false,
      feedback_type_options: [
        { value: 'click', label: '点击' },
        { value: 'official', label: '公众号' },
        { value: 'wecom', label: '企业微信' }
      ],
      options: [
        { value: 'ANDROID', label: '安卓' },
        { value: 'IOS', label: 'iOS' },
        { value: 'QUICK_APP', label: '快应用' },
        { value: 'WEB', label: 'Web' },
        { value: 'WECHAT_OFFICIAL_ACCOUNT', label: '微信公众号' },
        { value: 'WECHAT_CHANNELS', label: '微信视频号' },
        { value: 'WECHAT_MINI_PROGRAM', label: '微信小程序' },
        { value: 'WECOM', label: '企业微信' },
        { value: 'WECHAT_MINI_GAME', label: '微信小游戏' },
        { value: 'QQ_MINI_GAME', label: 'QQ小游戏' }
      ]
    }
  },
  // 页面初始化挂载dom
  mounted() {
    console.log('111')
    // this.$nextTick(() => {
    //   //  执行echarts方法
    //   this.getLoadEcharts()
    // })
    // this.getLoadEcharts()
  },
  methods: {
    selectID() {
      this.dialogVisibleId = true
      this.$nextTick(() => {
        this.$refs.id.send()
      })
    },
    close(item) {
      this.ruleForm.account_id = item.account_id
      this.account_name = item.account_name
      this.dialogVisibleId = false
    },

    clickicon(img, key, name, item) {
      if (img.endsWith('.mp4') || img.endsWith('.avi') || img.endsWith('.mov') || img.endsWith('.wmv')) {
        return this.$message.info('不是图片，请重新选择')
      } else {
        console.log('img, key:', img, key, name, item)
        this.dialogVisibletwo = false
        this.ruleForm.path = img
        this.ruleForm.md5 = item.md5
      }
    },
    bandarrMerchant(arr, sp_strategy_no, arrname) {
      console.log('66666', arr)
      this.dialogMerchant = false
      this.merchant_ids = arr
      this.ruleForm.merchant_ids = []
      arr.forEach(element => {
        this.ruleForm.merchant_ids.push(element.merchant_id)
        console.log('this.ruleForm.merchant_ids:', this.ruleForm.merchant_ids)
      })
    },
    merchantchat() {
      this.dialogVisibletwo = true
      setTimeout(() => {
        this.$refs.mychild.parentHandleclick('1')
      }, 100)
    },
    async submitForm(formName) {
      console.log(' this.ruleForm.agents_password :', this.ruleForm)

      this.$refs[formName].validate(async valid => {
        if (valid) {
          let isPass = true
          let isText = true

          for (let i = 0; i < this.ruleForm.url_info_list.length; i++) {
            const item = this.ruleForm.url_info_list[i]
            if (item.feedback_url === '' || item.feedback_type === '') {
              isPass = false
              break
            } else if (!item.feedback_url.includes('CLICK_ID') || !item.feedback_url.includes('CLICK_TIME') || !item.feedback_url.includes('ACCOUNT_ID') || !item.feedback_url.includes('CALLBACK')) {
              isText = false
              break
            }
          }

          if (isText) {
            // 数组中的所有元素都满足条件
            console.log('通过')
          } else {
            // 数组中至少有一个元素不满足条件
            console.log('不通过')
          }

          for (let i = 0; i < this.ruleForm.url_info_list.length; i++) {
            const item = this.ruleForm.url_info_list[i]
            if (item.feedback_url === '' || item.feedback_type === '') {
              isPass = false
              break
            }
          }

          if (isPass && isText) {
            this.$emit('submit', this.ruleForm, () => {
              this.ruleForm = {
                account_id: '',
                feedback_name: '',
                second_category_type: '',
                url_info_list: [
                  {
                    feedback_url: '',
                    feedback_type: ''
                  }
                ]
              }
            })
          } else if (!isPass) {
            // 数组中至少有一个元素不满足条件
            this.$message.info('监测链接组信息中不能为空或不选')
          } else if (!isText) {
            this.$message.info('监测链接必须包含CLICK_ID,CLICK_TIME,ACCOUNT_ID,CALLBACK')
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    wechatclick() {
      this.wechatVisible = true
      this.$nextTick(() => {
        this.$refs.wechatview.send()
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    async changewr(val, item) {
      console.log(val, item)
      // await setReceiveMiniprogram({
      //   receive_miniprogram: val,
      //   id: item.id
      // })
      this.$message({
        message: '修改成功',
        type: 'success'
      })
      this.list()
    },
    async send(row) {
      console.log('---', row)
      // const item = JSON.parse(JSON.stringify(row))
      // this.ruleForm.account_id = item.account_id
      // this.getlist(id, type)
    },
    add() {
      this.ruleForm.url_info_list.push({
        feedback_url: '',
        feedback_type: ''
      })
    },
    rightclick(index) {
      this.ruleForm.url_info_list.splice(index, 1)
    },
    rightclick2(index) {
      this.merchant_ids.splice(index, 1)
    }
  }
}
</script>
<style scoped>
.el-form-item {
  margin-bottom: 22px;
  margin: 10px;
}
.pic_img {
  width: 95px;
}
.item {
  display: flex;
  margin: 5px;
  justify-content: center;
  align-items: center;
}
.title {
  min-width: 50px;
  margin: 5px;
}
</style>
